var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('div',{class:_vm.$style.inner},[_c('div',{class:_vm.$style.bg},[_c('img',{class:_vm.$style.img,attrs:{"src":require("../../assets/img/loading2.svg")}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }